import React from 'react';
import AudioPlayer from './AudioPlayer';

export default function AudioPlayerModal({ open, music, title, meta, onClose, t }) {
  if (!open || !music) return null;
  return (
    <div className="audio-player-modal" onClick={onClose}>
      <div className="audio-player-modal__content" onClick={(event) => event.stopPropagation()}>
        <div className="audio-player-modal__header">
          <div>
            <strong>{title}</strong>
            {meta && <span>{meta}</span>}
          </div>
          <button onClick={onClose} aria-label={typeof t === 'function' ? t('common.close') : 'Close'}>×</button>
        </div>
        <div className="audio-player-modal__body">
          <AudioPlayer music={music} t={t} />
        </div>
      </div>
    </div>
  );
}
